import BarCode from 'react-barcode';
import React from 'react'


class ComponentToPrint extends React.Component {
    render() {
        return <div className="flex-container print-all-element" id="wrapper_ref_all">
            {this.props.downloadLocation.map((data) =>
                <div className="flex-item">
                    <BarCode
                        value={data.unit && data.unit.unit_id ? data.location_id + '_' + data.unit.unit_id : data.location_id}
                    />
                </div>
            )}
        </div>
    }
}
 export default ComponentToPrint;